export default [
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/views/index.vue'),
    meta: {
      title: 'Отчёты',
    },
    children: [
      {
        path: 'update-counter',
        name: 'update-counter',
        component: () => import('@/views/reports/update.vue'),
        meta: {
          title: 'История абонента',
        },
      },
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/reports/notice.vue'),
        meta: {
          title: 'Печать извещений',
        },
      },
      {
        path: 'history',
        name: 'reports-history',
        component: () => import('@/views/reports/history.vue'),
        meta: {
          title: 'История абонента',
        },
      },
      {
        path: 'history-list',
        name: 'reports-history-list',
        component: () => import('@/views/forms/history-list.vue'),
        meta: {
          title: 'История абонента',
        },
      },
      {
        path: 'customers',
        name: 'reports-customers',
        component: () => import('@/views/reports/customers.vue'),
        meta: {
          title: 'По абонентам',
        },
      },
      {
        path: 'customers-list',
        name: 'reports-customers-list',
        component: () => import('@/views/forms/customer-list.vue'),
        meta: {
          title: 'По абонентам',
        },
      },
      {
        path: 'streets',
        name: 'reports-streets',
        component: () => import('@/views/reports/streets.vue'),
        meta: {
          title: 'По улицам',
        },
      },
      {
        path: 'streets-list',
        name: 'reports-streets-list',
        component: () => import('@/views/forms/street-list.vue'),
        meta: {
          title: 'По улицам',
        },
      },
      {
        path: 'controllers',
        name: 'reports-controllers',
        component: () => import('@/views/reports/controllers.vue'),
        meta: {
          title: 'По контролёрам',
        },
      },
      {
        path: 'controllers-list',
        name: 'reports-controllers-list',
        component: () => import('@/views/forms/controller-list.vue'),
        meta: {
          title: 'По контролёрам',
        },
      },
      {
        path: 'close',
        name: 'reports-close',
        component: () => import('@/views/reports/close.vue'),
        meta: {
          title: 'Закрыть отчёт',
        },
      },
    ],
  },
]
